import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/paragraph.svg` */
export const ParagraphIcon = createTripletGlyphIcon('ParagraphIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.459 1.8623C13.7902 1.86252 14.0586 2.1307 14.0586 2.46191C14.0586 2.79315 13.7902 3.06131 13.459 3.06152H8.59961V13.541C8.59936 13.8721 8.33113 14.1405 8 14.1406C7.66886 14.1405 7.39966 13.8721 7.39941 13.541V3.06152H2.54102C2.20973 3.06142 1.94141 2.79322 1.94141 2.46191C1.94144 2.13063 2.20975 1.8624 2.54102 1.8623H13.459Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.1416 2.16992C15.4727 2.17019 15.7411 2.43844 15.7412 2.76953C15.7412 3.10074 15.4727 3.36888 15.1416 3.36914H9.60059V15.2334C9.60038 15.5643 9.33178 15.8325 9.00098 15.833C8.66973 15.833 8.4006 15.5646 8.40039 15.2334V3.36914H2.85938C2.528 3.36914 2.25879 3.1009 2.25879 2.76953C2.25892 2.43827 2.52809 2.16992 2.85938 2.16992H15.1416Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.1875 2.89355C20.6293 2.89355 20.9883 3.25153 20.9883 3.69336C20.9881 4.13502 20.6292 4.49316 20.1875 4.49316H12.7998V20.3115C12.7995 20.753 12.4415 21.1112 12 21.1113C11.5585 21.1112 11.1995 20.753 11.1992 20.3115V4.49316H3.81152C3.36993 4.49303 3.01192 4.13494 3.01172 3.69336C3.01172 3.25161 3.36981 2.89369 3.81152 2.89355H20.1875Z"
        fill="currentColor"
      />
    </svg>
  ),
});
